import Vue from 'vue'
import Vuex from 'vuex'
import { refreshToken } from '@/api/login'
import userModule from './modules/UsersModule'
import { getToken, setToken, removeToken } from 'util/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: userModule
  },
  state: {
    accessToken: getToken().accessToken,
    refreshToken: getToken().refreshToken
  },
  getters: {
  },
  mutations: {
    setToken (state, {accessToken, refreshToken}) {
      setToken(accessToken, refreshToken)
      state.accessToken = accessToken
      state.refreshToken = refreshToken
    },
    clearUser (state) {
      state.accessToken = ''
      state.refreshToken = ''
      removeToken()
    }
  },
  actions: {
    refreshUserToken ({commit, state}) {
      return new Promise((resolve, reject) => {
        refreshToken(state.refreshToken).then(function (response) {
          commit('setToken', {accessToken: response.data.access_token, refreshToken: response.data.refresh_token})
          state.user.user = response.data.user
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
})
